<template>
  <div>
    <template v-if="loading">
      <div class="tws-article-spinner">
        <tws-loading-spinner />
      </div>
    </template>

    <div
      v-else-if="exception"
      class="container exception-alert">
      <div class="row">
        <div class="col-lg-5 col-md-6 col-sm-6">
          <InfraPageAlert
            type="danger">
            {{ $t('content.exception') }}
          </InfraPageAlert>
        </div>
      </div>
    </div>
    <Article
      v-else
      :heading="article.heading"
      :preamble="article.preamble"
      :language="locale"
      :content="article.content"
      :image="article.image"
      :breadcrumbs="breadcrumbItems"
      :publishDate="article.publishDate"
      :tags="article.tags"
      :relatedArticles="article.relatedArticles"
      :moreArticles="article.moreArticles" />
  </div>
</template>

<script>
import { isLoggedIn } from '@/utils/user.utils'

import { applyReactInVueWithOptions } from '@/utils/react.utils'
import { GrootArticle } from 'groot-components'
import {
  InfraPageAlert,
  TwsLoadingSpinner
} from 'tws-vue-components'
import {
  mapActions,
  mapState
} from 'vuex'

export default {
  components: {
    Article: applyReactInVueWithOptions(GrootArticle),
    TwsLoadingSpinner,
    InfraPageAlert
  },
  data () {
    return {
      locale: this.$route.params?.locale
    }
  },
  computed: {
    ...mapState('Article', [
      'loading',
      'exception',
      'article'
    ]),
    breadcrumbItems () {
      return [
        {
          title: isLoggedIn() ? this.$t('breadcrumbs.dashboard-logged-in.title') : this.$t('breadcrumbs.dashboard.title'),
          path: isLoggedIn() ? '/dashboard' : '/',
          routerLink: false
        },
        {
          title: this.article.heading,
          path: null,
          routerLink: false
        }
      ]
    }
  },
  watch: {
    '$route.path' (newPath) {
      this.loadArticle(newPath)
    }
  },
  async created () {
    await this.loadArticle(this.$route.path)

  },
  methods: {
    ...mapActions('Article', ['loadArticle'])
  }
}

</script>

<style lang="scss" scoped>
.tws-article-spinner {
  padding: 20rem 0 20rem 0
}
</style>
